import routerFactory from '@/js/router/genericListViewFactory';
import {setupSPA} from '../utils/setupApp.js';
import RegistrationListApp from '../apps/registration/RegistrationListApp.vue';
import listViewStore from '../store/list_view_store';
import paginationStore from '../store/pagination_store.js';

window.SetupRegistrationList = (params) => setupSPA(RegistrationListApp, {
  ...params,
  storeModules: {
    // This is just for filters
    list: listViewStore,
    pagination: paginationStore,
  },
  router: routerFactory(params.props.basePath),
});
